import React, { useCallback, useRef, useState } from "react";
import { Button } from "antd";
import RcaTracking from "../../QC/RcaTracking/RcaTracking";
import AddRcaFormPopup from "../AddRcaFormPopup";
import "../DataOpsAnalytics.css";

/**
 * Data Ops RCA → RCA tab (QC RcaTracking + Add RCA).
 */
export default function DataOpsRcaTrackingTab({ embedded = false }) {
  const [addRcaOpen, setAddRcaOpen] = useState(false);
  const refreshTrackingRef = useRef(null);

  const registerTrackingRefresh = useCallback((refreshFn) => {
    refreshTrackingRef.current = refreshFn;
  }, []);

  const handleAddRcaClose = useCallback((shouldRefresh) => {
    setAddRcaOpen(false);
    if (shouldRefresh && refreshTrackingRef.current) {
      refreshTrackingRef.current();
    }
  }, []);

  const content = (
    <>
      <RcaTracking
        variant="dataOps"
        onRegisterRefresh={registerTrackingRefresh}
        filterActions={(
          <Button type="primary" onClick={() => setAddRcaOpen(true)}>
            Add RCA
          </Button>
        )}
      />
      <AddRcaFormPopup
        open={addRcaOpen}
        onCancel={handleAddRcaClose}
      />
    </>
  );

  if (embedded) {
    return <div className="DataOpsAnalytics__RcaTrackingTab">{content}</div>;
  }

  return (
    <div className="DataOpsAnalytics DataOpsAnalytics__RcaTrackingTab">
      {content}
    </div>
  );
}
